const API_BASE_URL = process.env.BASE_URL

export const PRICEBOOK_ENDPOINTS = {
    LIST: API_BASE_URL + "/{service_company_slug}/api/pricebook/",
}

export const SUBTYPE_ENDPOINTS = {
    USAGE_BY_TYPE: API_BASE_URL + "/{service_company_slug}/api/pricebook/subtypes/usage-by-type/",
}
